export default __webpack_public_path__ + "static/media/ico-delete.3527bbf7.svg";